import SkuPhotoManager from '../SkuPhotoManager';
import type { Sku } from '../../../types';

interface Props {
  sku: Sku;
}

export function SkuPhotosTab({ sku }: Props) {
  return <SkuPhotoManager skuId={sku.id} photos={sku.photos ?? []} />;
}
